<template>
  <div class="site__centered">

    <Breadcrumbs
      v-if="isParentRole"
      :items="[
        { label: 'My Account', name: 'home', type: 'route' },
        { label: programName, id: programId, type: 'program' },
        { label: 'Child Selection', name: '', type: 'route' }
      ]"
    />

    <div class="application form">
      <h2 class="application__title">Application Form</h2>
      <h2 class="application__program">Program name: <span>{{ programName }}</span></h2>
      <h4 class="application__subtitle">Select child to register for</h4>
      <div
        v-if="childrenList.length > 0"
      >
        <ChildItem 
          v-for="(child, index) in childrenList"
          :key="index"
          :child="child"
          :disabled="child.isDisabled"
          :disable-reason="child.disabledReason"
          @click.native="handleChildClick(child)"
        />
      </div>
      <button 
        class="btn btn--color-dark form__button"
        @click="addNewChild"
      >Add New +</button>
    </div>
    <AddNewChildModal 
      :is-show-modal="isShowModal"
      :default-gender="defaultProgramGender"
      :is-enable-select-gender="enableSelectGender"
      :family-name="parent.last_name"
      :family-id="parent.family_id"
      @closeModal="closeModal"
      @updateChildrenList="setChildrenList"
    />

    <AddChildMissingValueModal
      v-if="selectedChild"
      :is-show-modal="isShowSetMissingDataModal"
      :user="selectedChild"
      @closeModal="closeSetMissingValueModal"
      @updateChildrenList="setChildrenList"
    />

  </div>
</template>

<script>

  import { scrollToTop } from '@/helpers/scrollToTop'
  import ChildItem from '@/views/Children/ChildItem.vue'
  import AddNewChildModal from '@/components/site/add-new-child-modal/AddNewChildModal.vue'
  import store from '@/store'
  import { getUserData } from '@/auth/utils'
  import { prepareProgramRegistrationInfo } from '@core/mixins/prepareProgramRegistrationInfo'
  import { mapGetters } from 'vuex'
  import AddChildMissingValueModal from '@/components/site/AddChildMissingValueModal.vue'
  import Breadcrumbs from '@/components/site/breadcrumb/Breadcrumbs.vue'

  export default {
    name: 'ApplicationSelectChild',
    components: {
      Breadcrumbs,
      AddChildMissingValueModal,
      ChildItem,
      AddNewChildModal,
    },
    mixins: [ prepareProgramRegistrationInfo ],
    data() {
      return {
        parent: getUserData(),
        isParentRole: getUserData().role === 'parent',
        isShowModal: false,
        isShowSetMissingDataModal: false,
        selectedChild: null,
        programId: null,
        programName: '',
        defaultProgramGender: null,
        enableSelectGender: false,
        disableReason: '',
        isLoading: false,
      }
    },
    computed: {
      ...mapGetters({
        authSettings: 'authSettings/getAuthSettings',
        childrenList: 'children/getChildrenList',
        program: 'programs/getProgram',
      }),
    },
    watch: {
      $route() {
        if (this.$route.params.id !== this.programId) {
          this.programId = this.$router.currentRoute.params.id
          this.setProgramAndChildrenData()
        }
      },
    },
    async created() {
      this.programId = this.$router.currentRoute.params.id
      await this.setProgramAndChildrenData()
    },
    methods: {
      async setProgramAndChildrenData() {
        store.commit('SET_LOADING_STATUS', true)

        await store.dispatch('programs/fetchProgramById', this.programId)
          .then(response => {
            this.programName = response.name
            this.defaultProgramGender = this.getDefaultGenderForProgram(response.gender, this.authSettings)

            store.commit('children/SET_SELECTED_PROGRAM_AVAILABILITY_SETTINGS', response)

            this.enableSelectGender = response.gender === 'Both'
          })

        await this.setChildrenList()

        store.commit('SET_LOADING_STATUS', false)
      },
      handleChildClick(child) {
        if (child.ageIsEmpty || child.dynamicFieldIsEmpty) {
          this.selectedChild = child
          this.isShowSetMissingDataModal = true
        } else {
          this.$store.dispatch('children/goToApplicationPage', {
            child: child,
            programId: this.programId,
          })
        }
      },
      addNewChild() {
        scrollToTop()
        this.isShowModal = true
      },
      closeModal() {
        this.isShowModal = false
      },
      closeSetMissingValueModal() {
        this.isShowSetMissingDataModal = false
        this.selectedChild = null
      },
      async setChildrenList() {
        this.isLoading = true
        this.$emit('loading', true)

        await this.$store.dispatch('children/fetchChildrenList')
        await this.$store.dispatch('children/updateChildrenListWithProgramAccess')

        this.$emit('loading', false)

        this.isLoading = false
      },
    },
  }
</script>

<style scoped>
</style>